import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

const TestimonialSection = () => {
  return (
    <section className="testimonial-section fix bg-color3">
      <div className="testimonial-wrapper style1 section-padding">

        {/* Shapes */}
        <div className="shape">
          <img
            src="/assets/img/testimonial/left.jpg"
            alt="thumb"
          />
        </div>

        <div className="shape2">
          <img
            src="/assets/img/shape/testimonialShape1_1.png"
            alt="shape"
          />
        </div>

        <div className="container">
          <div className="row d-flex justify-content-end">

            <div className="col-xl-7">
              <div className="title-area">
                <div
                  className="sub-title text-center wow fadeInUp"
                  data-wow-delay="0.5s"
                >
                  <img
                    className="me-1"
                    src="/assets/img/icon/titleIcon.svg"
                    alt="icon"
                  />
                  Testimonials
                  <img
                    className="ms-1"
                    src="/assets/img/icon/titleIcon.svg"
                    alt="icon"
                  />
                </div>

                <h2
                  className="title text-white wow fadeInUp"
                  data-wow-delay="0.7s"
                >
                  What our Clients Say
                </h2>
              </div>

              {/* WORKING SWIPER SLIDER */}
              <div className="slider-area">
                <Swiper
                  modules={[Navigation, Autoplay]}
                  spaceBetween={30}
                  slidesPerView={1}
                  navigation={{
                    prevEl: ".arrow-prev",
                    nextEl: ".arrow-next",
                  }}
                  autoplay={{
                    delay: 3000,
                    disableOnInteraction: false,
                  }}
                  loop={true}
                  className="testmonialSliderOne"
                >

                  {/* Slider 1 */}
                  <SwiperSlide>
                    <div className="testimonial-card style1">
                      <div className="testimonial-header">
                        <div className="fancy-box">

                          <div className="item1">
                            <img
                              src="/assets/img/testimonial/Men.jpg"
                              alt="thumb"
                            />
                          </div>

                          <div className="item2">
                            <h6>Ronak Patel</h6>
                            <div className="icon">
                              <img
                                src="/assets/img/icon/star.svg"
                                alt="icon"
                              />
                            </div>
                          </div>

                          <div className="quote">
                            <img
                              src="/assets/img/icon/quote.svg"
                              alt="icon"
                            />
                          </div>

                        </div>
                      </div>

                      <p>
                   Spice Root Catering brought warmth and authentic taste to our family function.
                    Our guests were extremely happy and satisfied.
                      </p>
                    </div>
                  </SwiperSlide>

                  {/* Slider 2 */}
                  <SwiperSlide>
                    <div className="testimonial-card style1">
                      <div className="testimonial-header">
                        <div className="fancy-box">

                          <div className="item1">
                            <img
                              src="/assets/img/testimonial/Men2.jpg"
                              alt="thumb"
                            />
                          </div>

                          <div className="item2">
                            <h6>Mayur Sharma</h6>
                            <div className="icon">
                              <img
                                src="/assets/img/icon/star.svg"
                                alt="icon"
                              />
                            </div>
                          </div>

                          <div className="quote">
                            <img
                              src="/assets/img/icon/quote.svg"
                              alt="icon"
                            />
                          </div>

                        </div>
                      </div>

                      <p>
                        From starters to desserts, everything was perfectly organized. 
                        Guests loved the taste and variety. Highly recommended catering service.
                      </p>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="testimonial-card style1">
                      <div className="testimonial-header">
                        <div className="fancy-box">

                          <div className="item1">
                            <img
                              src="/assets/img/testimonial/1.png"
                              alt="thumb"
                            />
                          </div>

                          <div className="item2">
                            <h6>Harsh varma</h6>
                            <div className="icon">
                              <img
                                src="/assets/img/icon/star.svg"
                                alt="icon"
                              />
                            </div>
                          </div>

                          <div className="quote">
                            <img
                              src="/assets/img/icon/quote.svg"
                              alt="icon"
                            />
                          </div>

                        </div>
                      </div>

                      <p>
                       Authentic flavors, generous portions, and excellent service. Spice Root Catering brought traditional taste with a modern touch —
                        our guests were extremely happy.
                      </p>
                    </div>
                  </SwiperSlide>

                  <SwiperSlide>
                    <div className="testimonial-card style1">
                      <div className="testimonial-header">
                        <div className="fancy-box">

                          <div className="item1">
                            <img
                              src="/assets/img/testimonial/2.png"
                              alt="thumb"
                            />
                          </div>

                          <div className="item2">
                            <h6>Komal Patel</h6>
                            <div className="icon">
                              <img
                                src="/assets/img/icon/star.svg"
                                alt="icon"
                              />
                            </div>
                          </div>

                          <div className="quote">
                            <img
                              src="/assets/img/icon/quote.svg"
                              alt="icon"
                            />
                          </div>

                        </div>
                      </div>

                      <p>
                    {/* The variety of dishes, authentic flavors, and live counters created an amazing dining experience. */}
                     The service was professional, punctual, and well-organized. Our guests couldn’t stop praising the food.
                     We would absolutely choose Spice Root again.
                      </p>
                    </div>
                  </SwiperSlide>

                </Swiper>
              </div>

            </div>
          </div>
        </div>

        {/* Slider Arrows */}
        <div className="btn-wrap">
          <div className="arrow-prev">
            <i className="fa-regular fa-arrow-left"></i>
          </div>
          <div className="arrow-next">
            <i className="fa-regular fa-arrow-right"></i>
          </div>
        </div>

      </div>
    </section>
  );
};

export default TestimonialSection;
